export default "__VITE_ASSET__DIO$y8G5__"